import React from 'react';

const ArrowRightTable: React.FC<React.PropsWithChildren> = () => (
  <path d="M1 1L8 8L1 15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
);

export default ArrowRightTable;
